<script setup lang="ts">

import { usePresentation, DefaultSections } from '@presentation/Types';
const presentation = usePresentation();

</script>

<template>

    <div class="fixed w-full top-3 left-0 flex items-center gap-2 px-6 pt-5">
        
        <button 
            title="Open Slide Deck"
            @click="() => presentation.goto( DefaultSections.SlideSorter )"
            class="hover:brightness-110 hover:bg-white/[4%] rounded-full w-11 h-11 flex items-center justify-center hover:shadow tracking-wider">
            <Icon name="grid" />
        </button>
        
    </div>

</template>